import {
    EVENTS_TIMETABLE,
    EVENTS_ENTRY,
    ARTISTS_CONTACTS,
    LOGIN,
    NOTIFICATIONS_TIMETABLE
} from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { now } from '../../lib/date.utils';

const initialState = {
    fetching: false,
    zoom: 1,
    initialLeftScroll: 0,
    days: [],
    selectedDay: null,
    now: now(),
    stages: [],
    chatEnabled: false,
    entry: {
        contact: {
            contactFetching: false
        }
    },
    notifications: {
        fetched: false,
        fetching: false,
        data: []
    }
};

function timetable(state = initialState, action) {
    switch (action.type) {
        case EVENTS_TIMETABLE.FETCH_START:
            return { ...state, fetching: true };
        case EVENTS_TIMETABLE.FETCH_OK:
            return {
                ...state,
                days: action.days,
                fetching: false,
                selectedDay: action.selectedDay || state.selectedDay,
                stages: action.stages,
                chatEnabled: action.chatEnabled
            };
        case EVENTS_TIMETABLE.UPDATE:
            return { ...state, [action.field]: action.value };
        case EVENTS_TIMETABLE.SWITCH:
            return { ...state, selectedDay: action.day };
        case EVENTS_ENTRY.SHOW:
            return { ...state, entry: { ...action.entry, ...{ contact: { contactFetching: false } } } };
        case EVENTS_ENTRY.HIDE:
            return { ...state, entry: {} };
        case ARTISTS_CONTACTS.FETCH_START:
            return { ...state, entry: { ...state.entry, ...{ contact: { contactFetching: true } } } };
        case ARTISTS_CONTACTS.FETCH_OK:
            return {
                ...state,
                entry: { ...state.entry, ...{ contact: action.contact } }
            };
        case NOTIFICATIONS_TIMETABLE.FETCH_START:
            return { ...state, notifications: { ...state.notifications, fetching: true, data: [] } };
        case NOTIFICATIONS_TIMETABLE.FETCH_OK:
            return {
                ...state,
                notifications: { ...state.notifications, fetching: false, fetched: true, data: action.data }
            };
        case LOGIN.CANCEL:
        case LOCATION_CHANGE:
            return initialState;
        default:
            return state;
    }
}

export default timetable;
